<template>
  <v-container fluid class="pa-0" v-if="tabList.length > 0">

    <!-- Header -->
    <div class="d-flex justify-space-between align-center mb-7">
      <div>
        <div style="font-size: 30px; font-weight: 800">My Core Time</div>
        <div class="text-subtitle-2 mt-1">
          <span class="text-grey">Set and manage your OJT work schedule</span>
        </div>
      </div>
      <v-btn
      
        class="white--text"
        color="#00A63E"
        rounded="lg"
        prepend-icon="mdi-plus"
        size="large"
        @click="add_new()"
      >
        Create Schedule
      </v-btn>
    </div>

    <!-- Table -->
    <v-card flat class="rounded-xl table-card">
      <v-data-table
        :headers="headers"
        :items="table_data"
        :search="search"
        :loading="loading"
        hover
        class="rounded-xl"
      >
        <template v-slot:[`item.date_from`]="{ item }">
          <span>{{ formatDate(item.date_from) }}</span>
        </template>
        <template v-slot:[`item.date_to`]="{ item }">
          <span>{{ formatDate(item.date_to) }}</span>
        </template>
        <template v-slot:[`item.approval_status`]="{ item }">
          <v-chip
            size="x-small"
            :color="item.approval_status == 2 ? 'success' : item.approval_status == 3 ? 'error' : 'warning'"
            variant="tonal"
          >
            {{ item.approval_status == 2 ? 'Approved' : item.approval_status == 3 ? 'Returned' : 'For Approval' }}
          </v-chip>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-btn
            v-if="item.approval_status != 2"
            size="small"
            color="warning"
            variant="tonal"
            prepend-icon="mdi-pencil-outline"
            rounded="lg"
            @click="editItem(item)"
          >Edit</v-btn>
          <v-btn
            v-if="item.approval_status == 2"
            size="small"
            color="primary"
            variant="tonal"
            prepend-icon="mdi-eye-outline"
            rounded="lg"
            @click="viewItem(item)"
          >View</v-btn>
        </template>

        <template #no-data>
          <div class="text-center py-12">
            <v-icon size="48" color="grey-lighten-1">mdi-calendar-clock-outline</v-icon>
            <div class="text-body-1 font-weight-medium mt-3">No schedule created yet</div>
            <div class="text-caption text-grey mt-1 mb-5">Set your core time so your coordinator knows your availability.</div>
            <v-btn
              color="#00A63E"
              class="white--text"
              rounded="lg"
              prepend-icon="mdi-plus"
              @click="add_new()"
            >Create Schedule</v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- Dialogs -->
    <v-dialog v-model="dialogConfirmDelete" max-width="440">
      <v-card rounded="xl">
        <v-card-title class="text-body-1 font-weight-bold pa-5 pb-2">Confirm Deletion</v-card-title>
        <v-card-text class="text-body-2 text-grey-darken-1 pb-4">
          Are you sure you want to delete this item?
        </v-card-text>
        <v-card-actions class="pa-4 pt-0">
          <v-spacer />
          <v-btn variant="text" @click="dialogConfirmDelete = false">Cancel</v-btn>
          <v-btn color="error" variant="flat" rounded="lg" @click="confirmDelete">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <StudentCoretimeDialog :data="itemData" :action="action" />
    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    />
  </v-container>
</template>

<script>
import eventBus from "@/eventBus";
import StudentCoretimeDialog from "../Dialogs/Forms/StudentCoretimeDialog.vue";

export default {
  components: {
    StudentCoretimeDialog,
  },
  data: () => ({
    itemData: null,
    search: "",
    headers: [
      { title: "Date From",  value: "date_from",       align: "start" },
      { title: "Date To",    value: "date_to",          align: "start" },
      { title: "Status",     value: "approval_status",  align: "center" },
      { title: "Action",     value: "action",           align: "center", sortable: false },
    ],
    data: [],
    activeTab: { id: 1, name: "Duty Logs(DTR)" },
    tab: 1,
    tabList: [
      { id: 1, name: "Duty Logs(DTR)" },
      { id: 2, name: "Practicum" },
    ],
    programs_for: [],
    expandTab1: false,
    expandTab2: false,
    expandTab3: false,
    table_data: [],
    loading: false,
    options: {},
    action: null,
    paginationData: {},
    formdata: [],
    dialogConfirmDelete: false,
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "System Message!",
      message: "",
      top: 10,
    },
  }),
  mounted() {
    this.loadCoretime();
    eventBus.on("closeStudentCoretimeDialog", () => {
      this.loadCoretime();
    });
  },
  beforeUnmount() {
    eventBus.off("closeStudentCoretimeDialog");
  },
  methods: {
    formatType(type) {
      const labels = {
        am_in: "Morning Time In",
        am_out: "Morning Time Out",
        pm_in: "Afternoon Time In",
        pm_out: "Afternoon Time Out",
      };
      return labels[type] || type;
    },
    pagination(data) {
      this.paginationData = data;
    },
    add_new() {
      this.itemData = { id: null };
      this.action = "Add";
    },
    loadCoretime() {
      this.loading = true;
      this.axiosCall("/student-coretime/my", "GET").then((res) => {
        if (res) {
          this.table_data = res.data;
          this.loading = false;
        }
      });
    },
    changeTab(tab) {
      this.activeTab = tab.name;
      this.tab = tab.id;
      this.expandTab1 = false;
      this.expandTab2 = false;
      this.expandTab3 = false;
      this.initialize();
    },
    initialize() {},
    editItem(item) {
      this.itemData = item;
      this.action = "Update";
    },
    viewItem(item) {
      this.itemData = item;
      this.action = "View";
    },
    confirmDelete() {},
  },
};
</script>

<style scoped>
.table-card {
  border: 1px solid #d1d5db !important;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06) !important;
}
</style>
